import { Badge } from '@viastud/ui/badge'
import { Button } from '@viastud/ui/button'
import { Card, CardContent } from '@viastud/ui/card'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@viastud/ui/select'
import { GradeEnum } from '@viastud/utils'
import type * as React from 'react'

import { getBookingChapterImageSrc, type BookingChapter } from './booking-card.tsx'

interface BookingListCardProps {
  chapter: BookingChapter
  selectedModuleId?: number
  onModuleChange: (moduleId: number) => void
  disabled?: boolean
  onBook: (chapterId: number, moduleId: number) => void
}

export const BookingListCard: React.FC<BookingListCardProps> = ({
  chapter,
  selectedModuleId,
  onModuleChange,
  onBook,
  disabled,
}) => {
  const currentModuleId = selectedModuleId ?? chapter.modules[0]?.id
  const chapterNumber = chapter.modules.at(0)?.chapterNumber ?? 1
  const imageSrc = getBookingChapterImageSrc(chapter)

  const isTestChapter = chapter.name.toLowerCase().includes("cours d'essai")

  return (
    <Card className="flex h-full flex-col overflow-hidden">
      {imageSrc && <img src={imageSrc} alt={chapter.name} className="h-32 w-full object-contain" />}
      <CardContent className="flex flex-1 flex-col gap-4 p-4">
        <div className="flex flex-wrap gap-2">
          <Badge
            variant="secondary"
            className="bg-yellow-100 uppercase text-yellow-600 hover:bg-yellow-100"
          >
            {chapterNumber}
          </Badge>
          <Badge variant="secondary" className="bg-blue-100 text-blue-600 hover:bg-blue-100">
            {GradeEnum[chapter.grade as keyof typeof GradeEnum]}
          </Badge>
          {chapter.duration && (
            <Badge variant="secondary" className="bg-gray-50 text-gray-400 hover:bg-gray-50">
              {chapter.duration}
            </Badge>
          )}
        </div>

        <h3 className="line-clamp-2 text-lg font-bold leading-tight text-neutral-900">
          {chapter.name}
        </h3>

        <div className="mt-auto flex flex-col gap-4">
          <Select
            value={currentModuleId?.toString()}
            onValueChange={(val) => {
              onModuleChange(Number.parseInt(val))
            }}
            disabled={chapter.modules.length <= 1}
          >
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Choisir un module" />
            </SelectTrigger>
            <SelectContent>
              {chapter.modules.map((m) => (
                <SelectItem key={m.id} value={m.id.toString()}>
                  {m.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Button
            className="w-full"
            disabled={isTestChapter ? false : disabled}
            onClick={() => {
              if (currentModuleId) {
                onBook(chapter.id, currentModuleId)
              }
            }}
          >
            Réserver ce cours
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
